/**
 * Basic directive for setting up tooltips
 */
export default {
    /**
     * Initialises tooltip if value is truthy
     * @param {HTMLElement} el
     * @param {Object} binding
     */
    bind(el, binding) {
        if (binding.value) {
            $(el).tooltip();
        }
    },

    /**
     * Enables or disables the tooltip when value changes
     * @param {HTMLElement} el
     * @param {Object} binding
     */
    update(el, binding) {
        if (binding.value === binding.oldValue) {
            return;
        }

        if (binding.oldValue) {
            $(el).tooltip('destroy');
            return;
        }

        $(el).tooltip();
    },

    /**
     * Destroys the tooltip
     * @param {HTMLElement} el
     */
    unbind(el) {
        $(el).tooltip('destroy');
    },
};
